import React, { forwardRef, type HTMLAttributes } from 'react';
import { EditorSelectedElementProvider } from '~/contexts/EditorSelectedElementContext';
import RightSideMenu from '.';
import { InspectorPanel } from './container.styled';

const RightSideMenuContainer = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>((props, ref) => (
    <InspectorPanel ref={ref} {...props}>
        <EditorSelectedElementProvider>
            <RightSideMenu />
        </EditorSelectedElementProvider>
    </InspectorPanel>
));

export default RightSideMenuContainer;
